/* eslint-disable */

import { Button, Grid, Typography } from "@mui/material"
import theme, { textClasses, } from "../../../../static/styles/theme"
import { Add, Delete, Edit } from "@mui/icons-material"

const Table2 = ({ header, rows, remainingItems, handleAddRow, handleRemoveRow, handleEditRow, AddRow, isQuantityApplicable = true, isPalletEntry = false }) => {
    return (
        <Grid container sx={{ overflowX: "auto", width: "100%", textAlign: 'center', }}>
            <table
                style={{
                    // display: "block",
                    // maxWidth: "-moz-fit-content",
                    // maxWidth: "fit-content",
                    // margin: "0 auto",
                    // whiteSpace: "nowrap",
                    // borderRadius: "8px"
                    width: "100%",
                    textAlign: 'center'
                }}
            >
                <thead style={{ backgroundColor: theme.themeGray }}>
                    <tr style={{ ...textClasses.boldText, backgroundColor: theme.themeOrange, color: theme.themeWhite, padding: "10px" }}>

                        {
                            header.slice(0, 1).map((head, i) => {
                                return (
                                    <td style={{ border: `1px solid ${theme.themeWhite}`, padding: "10px", width: "150px" }} key={i}>{head}</td>
                                )
                            })
                        }
                        {
                            header.slice(1, header.length).map((head, i) => {
                                return (
                                    <td style={{ border: `1px solid ${theme.themeWhite}` }} key={i}>{head}</td>
                                )
                            })
                        }

                        {(handleEditRow || handleRemoveRow) && <td style={{ border: `1px solid ${theme.themeWhite}` }}>Action</td>}
                    </tr>
                </thead>
                <tbody>
                    {
                        rows.length > 0
                        &&
                        <>
                            {
                                rows.map((row, i) => (
                                    <tr key={i} style={{ borderBottom: "1px solid #0000002B" }}>
                                        {row.map((col, j) => (
                                            <td key={j} style={{
                                                padding: "10px", border: `1px solid ${theme.themeGray}`, backgroundColor: (i == 0 && isPalletEntry) ? theme.themeLightOrange : "inherit",
                                            }}>
                                                {col}
                                            </td>
                                        ))}

                                        {/* Check if either edit or remove handlers exist before rendering this cell */}
                                        {(handleEditRow || handleRemoveRow) && (
                                            <td style={{
                                                padding: "10px", border: `1px solid ${theme.themeGray}`, width: "120px", backgroundColor: (i == 0 && isPalletEntry) ? theme.themeLightOrange : "inherit",
                                            }}>
                                                <Grid container justifyContent="center" alignItems="center" direction="row" wrap="nowrap">

                                                    {/* Show Edit button only if handleEditRow is provided */}
                                                    {handleEditRow && (
                                                        <Button
                                                            variant="outlined"
                                                            className="RF_outline-btn"
                                                            sx={{
                                                                borderRadius: "8px",
                                                                p: 0,
                                                                height: "40px",
                                                                minWidth: "40px",
                                                                border: `1px solid ${theme.themeBlack}`,
                                                            }}
                                                            onClick={() => handleEditRow(i)}
                                                        >
                                                            <Edit sx={{ color: theme.themeBlack }} />
                                                        </Button>
                                                    )}

                                                    {/* Show Delete button only if handleRemoveRow is provided */}
                                                    {handleRemoveRow && (
                                                        <Button
                                                            variant="outlined"
                                                            className="RF_outline-btn"
                                                            sx={{
                                                                borderRadius: "8px",
                                                                ml: 1,
                                                                p: 0,
                                                                height: "40px",
                                                                minWidth: "40px",
                                                                border: `1px solid ${theme.themeBlack}`,
                                                            }}
                                                            onClick={() => handleRemoveRow(i)}
                                                        >
                                                            <Delete sx={{ color: theme.themeBlack }} />
                                                        </Button>
                                                    )}
                                                </Grid>
                                            </td>
                                        )}
                                    </tr>

                                ))
                            }
                        </>
                    }
                    {handleAddRow &&
                        <tr>
                            <td style={{ padding: "10px", border: `1px solid ${theme.themeGray}`, textAlign: "left" }} colSpan={header?.length + 1}>
                                <Typography
                                    sx={{
                                        ...textClasses.boldText,
                                        color: (remainingItems > 0 || AddRow || !isQuantityApplicable) ? theme.themeOrange : "#D7D7D7",
                                        textDecoration: "underline",
                                        cursor: (remainingItems > 0 || AddRow || !isQuantityApplicable) ? "pointer" : "default",
                                        width: 'fit-content',
                                    }}
                                    onClick={() =>
                                        (remainingItems > 0 || AddRow || !isQuantityApplicable) ? handleAddRow() : undefined
                                    }
                                >
                                    <Add fontSize="inherit" />
                                    Add More Items
                                </Typography>
                            </td>
                            {/* {
                            header.map((_, i) => {
                                return (<td style={{padding: "10px", border: "1px solid #D9D9D9"}} key={i}></td>)
                            })
                        } */}
                        </tr>
                    }

                </tbody>
            </table>
        </Grid>
    )
}

export default Table2;